/*
Theme-only card previews. 50 of 55 posts have no feature_image, so their cards show a
branded placeholder. This fetches each placeholder card's post page, grabs the first
content image, and uses it as the card thumbnail — without any content/DB changes.

Results are cached in sessionStorage so pagination and revisits are instant.
Concurrency-limited and fully graceful: on any failure the branded placeholder stays.
*/

function sizedGhostUrl(src) {
    try {
        if (src.includes('/content/images/') && !/\/content\/images\/size\//.test(src)) {
            return src.replace('/content/images/', '/content/images/size/w600/');
        }
    } catch (e) {
        /* noop */
    }
    return src;
}

async function firstImageForPost(url) {
    const key = 'mnr-thumb:' + url;
    try {
        const cached = sessionStorage.getItem(key);
        if (cached !== null) return cached;
    } catch (e) {
        /* sessionStorage unavailable */
    }

    let result = '';
    try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (res.ok) {
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const img = doc.querySelector('.gh-content img');
            const raw = img && img.getAttribute('src');
            if (raw) result = new URL(raw, url).href;
        }
    } catch (e) {
        /* keep placeholder */
    }

    try {
        sessionStorage.setItem(key, result);
    } catch (e) {
        /* noop */
    }
    return result;
}

function applyThumbnail(card, src) {
    const media = card.querySelector('.mnr-tool-card__media');
    const placeholder = card.querySelector('.mnr-tool-card__placeholder');
    if (!media || !placeholder) return;

    const img = document.createElement('img');
    img.className = 'gh-card-image';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = '';
    img.addEventListener('load', () => placeholder.remove());
    img.addEventListener('error', () => img.remove());
    img.src = sizedGhostUrl(src);

    media.insertBefore(img, placeholder);
}

export default async function populateCardThumbnails(root) {
    const scope = root || document;
    const jobs = Array.from(scope.querySelectorAll('.mnr-tool-card'))
        .filter((card) => card.querySelector('.mnr-tool-card__placeholder') && !card.dataset.thumbDone)
        .map((card) => {
            card.dataset.thumbDone = '1';
            const link = card.querySelector('a[href]');
            return { card, url: link && link.href };
        })
        .filter((job) => job.url);

    if (!jobs.length) return;

    const CONCURRENCY = 4;
    let index = 0;

    async function worker() {
        while (index < jobs.length) {
            const job = jobs[index++];
            const src = await firstImageForPost(job.url);
            if (src) applyThumbnail(job.card, src);
        }
    }

    await Promise.all(
        Array.from({ length: Math.min(CONCURRENCY, jobs.length) }, worker)
    );
}
